import React, {useState, useEffect} from "react";
import Table from "../../../../../app/components/Table"
import Pagination from "../../../../../app/components/Pagination";

const Read = ({setCount}) => {
    const columns = [
    { campo: 'remetente', titulo: 'Remetente' },
    { campo: 'assunto', titulo: 'Assunto' },
    { campo: 'destinatario', titulo: 'Destinatários' },
    { campo: 'templates', titulo: 'Templates' },
    { campo: 'status', titulo: 'Status' },
    { campo: 'enviado_em', titulo: 'Enviado em' },
  ];

  const [dataRead, setDataRead] = useState([
      { id: 1, remetente: 'smtp@mkt.odoscontabilidade.com.br', assunto: 'Lembrete: Apuração de impostos', destinatario: 'empresaemail@gmail.com', templates: 'Reenvio 1 - Apuração', status: 'Lido', enviado_em: '20/06/2025, 20:18:05'},
      { id: 2, remetente: 'smtp@mkt.odoscontabilidade.com.br', assunto: 'Lembrete: Apuração de impostos', destinatario: 'empresaemail@gmail.com', templates: 'Reenvio 1 - Apuração', status: 'Lido', enviado_em: '20/06/2025, 20:18:05'},
      { id: 3, remetente: 'smtp@mkt.odoscontabilidade.com.br', assunto: 'Lembrete: Apuração de impostos', destinatario: 'empresaemail@gmail.com', templates: 'Reenvio 1 - Apuração', status: 'Lido', enviado_em: '20/06/2025, 20:18:05'},
      { id: 4, remetente: 'smtp@mkt.odoscontabilidade.com.br', assunto: 'Lembrete: Apuração de impostos', destinatario: 'empresaemail@gmail.com', templates: 'Reenvio 1 - Apuração', status: 'Lido', enviado_em: '20/06/2025, 20:18:05'},
      { id: 5, remetente: 'smtp@mkt.odoscontabilidade.com.br', assunto: 'Lembrete: Apuração de impostos', destinatario: 'empresaemail@gmail.com', templates: 'Reenvio 1 - Apuração', status: 'Lido', enviado_em: '20/06/2025, 20:18:05'},
      { id: 6, remetente: 'smtp@mkt.odoscontabilidade.com.br', assunto: 'Lembrete: Apuração de impostos', destinatario: 'empresaemail@gmail.com', templates: 'Reenvio 1 - Apuração', status: 'Lido', enviado_em: '20/06/2025, 20:18:05'},
      { id: 7, remetente: 'smtp@mkt.odoscontabilidade.com.br', assunto: 'Lembrete: Apuração de impostos', destinatario: 'empresaemail@gmail.com', templates: 'Reenvio 1 - Apuração', status: 'Lido', enviado_em: '20/06/2025, 20:18:05'},
    ]);

    useEffect(() => {
        setCount(dataRead.length);
    }, [dataRead, setCount]);

    const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  const totalPages = Math.ceil(dataRead.length / itemsPerPage);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const indexStart = (currentPage - 1) * itemsPerPage;
  const indexEnd = indexStart + itemsPerPage;
  const paginatedData = dataRead.slice(indexStart, indexEnd);

  return (
    <div>
      {paginatedData.length > 0 ? (
      <>
        <Table colunas={columns} dados={paginatedData} />

        {dataRead.length > itemsPerPage && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            showPageNumbers={true}
            maxPageNumbers={8}
          />
        )}
      </>
    ) : (
      <div className="text-center text-gray-500 py-8">
        Nenhum e-mail foi lido.
      </div>
    )}
    </div>
  );
};

export default Read